export const CONTACT_EMAIL = 'contact-us@navigatorofshame.com'
export const SHAME_LOGIC_URL = 'https://shamelogic.com'
export const APP_NAME = 'Tab of Shame'
export const APP_TAGLINE = 'The bar tab calculator that talks back.'

export const SITE_URL = 'https://tab.shamelogic.com'
export const PRIVACY_URL = `${SITE_URL}/privacy.html`
export const EULA_URL = `${SITE_URL}/eula.html`

export const LEGAL_UPDATED = 'September 18, 2026'

export type LegalSection = { heading: string; body: string[] }

export const PRIVACY_SECTIONS: LegalSection[] = [
  {
    heading: 'The short version',
    body: [
      'Tab of Shame has no account, no login, and no server that stores your tabs. Bills you type, photos you scan, and tips you log stay on your device. We cannot see where you drank, because that information is never sent to us.',
    ],
  },
  {
    heading: 'Tabs and history',
    body: [
      'Venue names, amounts, tip percentages, dates, and categories are stored only on your device. History older than twelve weeks is deleted automatically. Clearing history or deleting the app removes all of it.',
    ],
  },
  {
    heading: 'Camera and bill photos',
    body: [
      'Scanning a bill uses the camera or photo library you choose. Optical character recognition runs on the device. The photo is used to read amounts and is not uploaded. We do not keep a copy of your receipt.',
    ],
  },
  {
    heading: 'Sharing',
    body: [
      'When you tap Share tab card or Share weekly damage, the app builds a branded image on your device and opens the system share sheet. You choose where it goes. We do not receive that image or who you send it to.',
    ],
  },
  {
    heading: 'House ads',
    body: [
      'The banner at the top and buttons such as Get home roasted promote other Shame Logic apps, starting with Navigator of Shame. These are our own links, not a third-party ad network. Tapping one tries to open Navigator if installed, otherwise Safari with standard marketing link parameters so we can see which screen referred you. Tab of Shame does not include analytics SDKs or track you inside this app.',
    ],
  },
  {
    heading: 'Purchases',
    body: [
      'This app is free. There are no subscriptions, no in-app purchases, and no paywall.',
    ],
  },
  {
    heading: 'Analytics',
    body: [
      'The app does not send analytics to a third-party tracker. There is no advertising SDK.',
    ],
  },
  {
    heading: "Children's privacy",
    body: [
      'Tab of Shame is not directed at children under 13, and we do not knowingly collect personal information from children under 13.',
    ],
  },
  {
    heading: 'Your choices',
    body: [
      'You can deny camera access and still enter tabs by hand. You can clear history in the app. Deleting the app removes remaining data from the device.',
    ],
  },
]

export const TERMS_SECTIONS: LegalSection[] = [
  {
    heading: 'Acceptance',
    body: [
      'By using Tab of Shame you agree to these Terms of Use. If you do not agree, do not use the app. These terms are between you and Shame Logic LLC, and our Privacy Policy is incorporated by reference.',
    ],
  },
  {
    heading: 'License',
    body: [
      'We grant you a limited, non-exclusive, non-transferable, revocable license to use the app on devices you own or control. You may not copy, modify, reverse engineer, or redistribute the app except as permitted by law.',
    ],
  },
  {
    heading: 'What the app does',
    body: [
      'Tab of Shame is a tip calculator and a personal log of recent bar and restaurant tabs. It can suggest 18%, 20%, 25%, or 30% tips, scan a printed bill to estimate the amount due, and show humorous roast lines based on what you log.',
      'Roast lines are written for comic effect and are entertainment, not financial, tax, or etiquette advice. Suggested tips are math, not a legal requirement.',
    ],
  },
  {
    heading: 'Receipt scanning',
    body: [
      'Bill scanning uses on-device text recognition. Receipts are messy. The amount it finds can be wrong. Always check the number before you tip or save. You are responsible for the tip you actually leave.',
    ],
  },
  {
    heading: 'Not accounting software',
    body: [
      'This is a convenience tool, not bookkeeping, tax software, or a payment app. It does not charge a card, split a check with a processor, or file anything with anyone.',
    ],
  },
  {
    heading: 'Content',
    body: [
      'Roast lines are not directed at any individual. Venue names and notes you enter are your responsibility. The app, its design, roast lines, and branding remain owned by Shame Logic LLC.',
    ],
  },
  {
    heading: 'Disclaimer and liability',
    body: [
      'The app is provided “as is” and “as available” without warranties of any kind, express or implied, including merchantability, fitness for a particular purpose, and non-infringement.',
      'To the maximum extent permitted by law, Shame Logic LLC shall not be liable for any indirect, incidental, special, consequential, or punitive damages arising from your use of the app, including incorrect OCR, tipping disputes, or lost data. Our total liability shall not exceed the amount you paid for the app, which is zero.',
    ],
  },
  {
    heading: 'Termination and changes',
    body: [
      'You may stop using the app at any time by deleting it. We may modify these Terms by updating the date above; continued use after changes constitutes acceptance. These Terms are governed by the laws of the United States.',
    ],
  },
  {
    heading: 'Apple-specific terms',
    body: [
      'This agreement is between you and Shame Logic LLC, not Apple Inc. Apple is not responsible for the app or its content and has no obligation to provide maintenance or support. Apple and its subsidiaries are third-party beneficiaries of these Terms and may enforce them against you.',
    ],
  },
]
